import { ref, watch, computed } from '@vue/composition-api';
import usePersistedPerPage from '@/libs/utils/perPage';

// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

import store from '@/store';

export default function useCourseSectionAttendance(courseSectionData) {
  // Use toast
  const toast = useToast();

  const refAttendanceTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'student.fullName', stickyColumn: true, variant: 'primary', sortable: true, label: 'Student Name', tdClass: 'sticky-primary' },
  ];
  const dynamicTableColumns = [];

  const perPage = usePersistedPerPage('courseSectionAttendance', 10);
  const totalAttendances = ref(0);
  const currentPage = ref(1);
  const totalPageCount = ref(0);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('student.fullName');
  const isSortDirDesc = ref(false);
  const isFocusEnrolled = ref(true);

  const visibilityFilter = ref(null);
  const statusFilter = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refAttendanceTable.value ? refAttendanceTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalAttendances.value,
    };
  });

  const refetchData = () => {
    if (refAttendanceTable.value) {
      return refAttendanceTable.value.refresh();
    }
  };

  watch([currentPage, perPage, searchQuery, courseSectionData, isFocusEnrolled], () => {
    refetchData();
  });

  const fetchAttendance = (ctx, callback) => {
    const sbv = sortBy.value === 'id' ? '_id' : sortBy.value;
    const sb = `${sbv}:${isSortDirDesc.value ? 'desc' : 'asc'}`;

    const pl = {
      search: searchQuery.value,
      limit: perPage.value,
      page: currentPage.value,
      sortBy: sb,

      onlyActive: isFocusEnrolled.value,
      populate: 'student,profile',
    };

    store
      .dispatch('rosterStoreModule/fetchSessionAttendance', { queryParams: pl, sectionId: courseSectionData.id })
      .then((response) => {
        const { results, totalResults, totalPages } = response.data;

        callback(
          results.map((result) => {
            // result._rowVariant = ['terminated', 'withdrew_s1', 'withdrew_s2', 'withdrew_s3'].includes(result.profile.status) ? 'info' : '';
            return result;
          }),
        );
        totalAttendances.value = totalResults;
        totalPageCount.value = totalPages;
      })
      .catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching session attendance',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error.response ? error.response.data.message : error.message,
          },
        });
      });
  };

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  // const statusOptions = [
  //   { label: 'Created', value: 'created' },
  //   { label: 'Enrolling', value: 'enrolling' },
  //   { label: 'Waiting', value: 'waiting' },
  //   { label: 'Live', value: 'live' },
  //   { label: 'Completed', value: 'completed' },
  // ];

  return {
    fetchAttendance,
    tableColumns,
    dynamicTableColumns,
    perPage,
    currentPage,
    totalPageCount,
    totalAttendances,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refAttendanceTable,
    isFocusEnrolled,

    refetchData,

    // Extra Filters
  };
}
